import styles from "../items-slider.module.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { PrevArrow } from "../../../../slick-slider-arrows/prev-arrow";
import { NextArrow } from "../../../../slick-slider-arrows/next-arrow";

export const ArkanesSlider = () => {
  const slickSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    nextArrow: <NextArrow itemsSlider={true} />,
    prevArrow: <PrevArrow itemsSlider={true} />,
    adaptiveHeight: true,
    responsive: [
      { breakpoint: 1520, settings: { slidesToShow: 4 } },
      { breakpoint: 1090, settings: { slidesToShow: 3 } },
      { breakpoint: 835, settings: { slidesToShow: 2 } },
      { breakpoint: 605, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <Slider {...slickSliderSettings}>
      <div className={styles["slick-slider-item"]}>
        <img src="/assets/images/items/arkanes/arkane-01.png" alt="" />
        <div className={styles["slick-slider-item-content"]}></div>
      </div>

      <div className={styles["slick-slider-item"]}>
        <img src="/assets/images/items/arkanes/arkane-02.png" alt="" />
        <div className={styles["slick-slider-item-content"]}></div>
      </div>

      <div className={styles["slick-slider-item"]}>
        <img src="/assets/images/items/arkanes/arkane-03.png" alt="" />
        <div className={styles["slick-slider-item-content"]}></div>
      </div>

      <div className={styles["slick-slider-item"]}>
        <img src="/assets/images/items/arkanes/arkane-04.png" alt="" />
        <div className={styles["slick-slider-item-content"]}></div>
      </div>

      <div className={styles["slick-slider-item"]}>
        <img src="/assets/images/items/arkanes/arkane-05.png" alt="" />
        <div className={styles["slick-slider-item-content"]}></div>
      </div>
      <div className={styles["slick-slider-item"]}>
        <img src="/assets/images/items/arkanes/arkane-06.png" alt="" />
        <div className={styles["slick-slider-item-content"]}></div>
      </div>
    </Slider>
  );
};
